import React from 'react'
import L from 'react-loadable'
import LoadingInline from '../loadingInContent'

const Loading = () => (
    <div className="module loadableRouteFull !rounded-md">
        <LoadingInline />
    </div>
)

export default opts => L({
    loading: Loading,
    ...opts,
})


// WEBPACK FOOTER //
// ./src/app/components/features/share/loadable/loadableRoute.js